import React from 'react';
import { Maximize2 } from 'react-feather';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import EditAvis from './SingleAvis/EditAvis';
import './AvisList/avisDetailModal.scss';

export const AvisDetailModalTrigger = ({ avisId, onOpen }) => {
    if (!avisId) {
        return null;
    }

    return (
        <button
            type="button"
            className="avis-detail-modal-trigger"
            onClick={() => onOpen(avisId)}
            aria-label={`Ouvrir l'avis ${avisId} dans une fenetre modale`}
            title="Ouvrir dans une fenetre modale"
        >
            <Maximize2 aria-hidden="true" />
        </button>
    );
};

const AvisDetailModal = ({ avisId, isOpen, toggle }) => (
    <Modal
        isOpen={isOpen}
        toggle={toggle}
        size="xl"
        centered
        scrollable
        zIndex={2300}
        className="avis-detail-modal"
        modalClassName="avis-detail-modal-overlay"
        backdropClassName="avis-detail-modal-backdrop"
        contentClassName="avis-detail-modal__content"
    >
        <ModalHeader toggle={toggle} className="avis-detail-modal__header">
            Avis : {avisId}
        </ModalHeader>
        <ModalBody className="avis-detail-modal__body">
            {avisId ? <EditAvis avis={avisId} /> : null}
        </ModalBody>
        <ModalFooter className="avis-detail-modal__footer">
            <button type="button" onClick={toggle} className="btn btn-secondary">Fermer</button>
        </ModalFooter>
    </Modal>
);

export default AvisDetailModal;
